import { defineStore } from 'pinia';

export const useDeliveryStore = defineStore('deliveryStore', {
    state: () => ({
        suggestions: [],
        address: '',
        coords: null,
        zone: { id: 1, name: 'Зона 1', coeff: 1.00 },

        out_of_zones: false,
        distance_km: null,

        // Центр и зоны
        center: [55.462540, 37.781900],
        zones: [
            { id: 1, name: 'Зона 1', from_km: 0,  to_km: 10,  coeff: 1.00 },
            { id: 2, name: 'Зона 2', from_km: 10, to_km: 25,  coeff: 1.15 },
            { id: 3, name: 'Зона 3', from_km: 25, to_km: 45,  coeff: 1.30 },
            { id: 4, name: 'Зона 4', from_km: 45, to_km: 70,  coeff: 1.50 },
            { id: 5, name: 'Зона 5', from_km: 70, to_km: 100, coeff: 1.75 },
        ],

        // Только два режима времени
        timeMode: 'in_day', // 'in_day' | 'exact'

        // Только МАНИПУЛЯТОР
        kind: 'manipulator',
        vehicle: '6m',

        vehicles: {
            manipulator: [
                { id: '6m',  label: 'Манипулятор 6м',  maxLenM: 6,  crane: true },
                { id: '12m', label: 'Манипулятор 12м', maxLenM: 12, crane: true },
                { id: 'mixer', label: 'Бетономешалка', maxLenM: 12, crane: true },
            ]
        },

        // База (в течение дня) для Зоны-1 — поставь свои прайсовые значения
        baseZone1InDay: {
            manipulator: {
                '6m':  9399,
                '12m': 9399,
                'mixer': 9399,
            }
        },

        // Мультипликаторы времени
        timeMultipliers: {
            in_day: 1.000,
            exact:  2.305,
        },
    }),

    getters: {
        // База «в течение дня» для Зоны-1 по выбранному кузову манипулятора
        baseInDayZone1(state) {
            const val = state.baseZone1InDay.manipulator?.[state.vehicle];
            return typeof val === 'number' ? val : 0;
        },

        // Цена с учётом зоны и выбранного режима
        rawPrice(state) {
            const inDayZone1 = this.baseInDayZone1;
            const zoneK = state.zone?.coeff ?? 1;
            const timeK = state.timeMultipliers[state.timeMode] ?? 1;
            return inDayZone1 * zoneK * timeK;
        },

        // Маркетинговое округление
        finalPriceRub() {
            const ceil10 = Math.ceil(this.rawPrice / 10) * 10;
            return Math.max(0, ceil10 - 1);
        },

        finalPriceStr() {
            return new Intl.NumberFormat('ru-RU').format(this.finalPriceRub) + ' ₽';
        },
    },

    actions: {
        setAddress(address) { this.address = address; },
        setZone(zone) { this.zone = zone || { id: 1, name: 'Зона 1', coeff: 1 }; },
        // kind фиксируем как 'manipulator'
        setVehicle(v) { this.vehicle = v; },
        setTimeMode(m) { this.timeMode = (m === 'in_day' || m === 'exact') ? m : 'in_day'; },
        setCenter(center) { this.center = Array.isArray(center) ? center : this.center; },
        setZones(zones) { if (Array.isArray(zones) && zones.length) this.zones = zones; },

        setCoords(coords) {
            this.coords = coords;
            this._updateZoneByCoords();
        },

        _haversineKm([lat1, lon1], [lat2, lon2]) {
            const toRad = x => x * Math.PI / 180;
            const R = 6371;
            const dLat = toRad(lat2 - lat1);
            const dLon = toRad(lon2 - lon1);
            const a = Math.sin(dLat/2)**2 +
                Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon/2)**2;
            return 2 * R * Math.asin(Math.sqrt(a));
        },

        _updateZoneByCoords() {
            if (!Array.isArray(this.coords) || this.coords.length !== 2) return;

            const dist = this._haversineKm(this.center, this.coords);
            this.distance_km = +dist.toFixed(1);

            let found = null;
            for (const z of this.zones) {
                if (dist >= z.from_km && dist < z.to_km) { found = z; break; }
            }

            if (found) {
                this.out_of_zones = false;
                this.setZone(found);
            } else {
                this.out_of_zones = true;
                const last = this.zones[this.zones.length - 1];
                this.setZone({ id: 'beyond', name: 'За зоной', from_km: last.to_km, to_km: Infinity, coeff: last?.coeff ?? 1.75 });
            }
        },
    },
});
